import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseAttachments = async (houseId) => {
  return await request.get(
    `/HousingStock/house/${houseId}/attachments`,
    {},
    'При загрузке документов по помещению произошла ошибка',
    []
  );
};

const useHouseAttachments = (houseId, options = {}) =>
  useQuery(
    getQueryKeys.houseAttachments(houseId),
    () => getHouseAttachments(houseId),
    {
      placeholderData: [],
      enabled: Boolean(houseId),
      ...options,
    }
  );

export default useHouseAttachments;
